import axioPath from '../../../api/axioPath';
import ptPlusApiBaseUrl from '../../../api/ptPlusApiBaseUrl';

export const adminDashboardRequestCountApi = () => (dispatch) => {
    const token = localStorage.getItem("token")
    return axioPath
        .get('/users/dalancey-to-approved-count', {
            headers: {
                Authorization: `${token}`,
            },
        }).then((response) => {
            if (response.data) dispatch({ type: 'NOTIFICATION_COUNT_ADMIN_DASHBOARD_USER_REQUEST', payload: response.data });
        }).catch((ex) => {
        });
};

export const adminResCenterRequestCountApi = () => (dispatch) => {
    const token = localStorage.getItem("token")
    return axioPath
        .get('/order/resolution/escalated_claim_list_count', {
            headers: {
                Authorization: `${token}`,
            },
        }).then((response) => {
            if (response.data) dispatch({ type: 'NOTIFICATION_COUNT_ADMIN_RES_CENTER', payload: response.data });
        }).catch((ex) => {
        });
};

export const requestOrderCountApi = () => (dispatch) => {
    const token = localStorage.getItem("token")
    return ptPlusApiBaseUrl
        .get('/ptms/order/admin/order_list_count', {
            headers: {
                Authorization: `${token}`,
                UserType: 'internal'
            },
        }).then((response) => {
            if (response.data) dispatch({ type: 'NOTIFICATION_COUNT_REQUEST_ORDERS', payload: response.data?.data });
        }).catch((ex) => {
        });
};

export const orderChatCountApi = (token, locationId) => (dispatch) => {
    return axioPath
        .get(`/order/chat_unread_count/${locationId}`, {
            headers: {
                Authorization: `${token}`,
            },
        }).then((response) => {
            if (response.data || response.data === 0) dispatch({ type: 'NOTIFICATION_COUNT_ORDER_CHAT', payload: response.data });
        }).catch((ex) => {
        });
};